import openSocket from 'socket.io-client';

import {store} from '../redux/StoreReducers';

const url =
    process.env.NODE_ENV === 'test'
        ? ''
        : `${process.env.REACT_APP_API_ENDPOINT}`;

const getToken = () => store.getState().sessionReducer?.session?.token || '';

export const socket = openSocket(url, {
    withCredentials: true,
    autoConnect: false,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    query: {token: getToken()},
});

store.subscribe(() => {
    const token = getToken();

    if (token && socket.io.opts.query.token !== token) {
        socket.io.opts.query.token = token;
        socket.disconnect();
        socket.connect();
    } else if (!token && socket.connected) {
        socket.disconnect();
    }
});

if (getToken()) {
    socket.connect();
}
